import {
  DataGrid,
  GridCellParams,
  GridColDef,
  GridSelectionModel,
} from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import { Item } from '../../utils/sharedTypes';
import { FirmwareFilter } from './linksTypes';
import { useFindAllFirmwareQuery } from '../../api/api-hooks';
import { Firmware } from '../../api/api-generated';
import { filterFirmware } from './linksUtils';
import LinkNewTab from '../../components/LinkNewTab';
import { useGridSort } from '../../hooks/useGridSort';

interface Props {
  setSelectedFirmware: React.Dispatch<React.SetStateAction<Item[]>>;
  filters: FirmwareFilter;
}

const FirmwareTable = ({ setSelectedFirmware, filters }: Props) => {
  const { data: allFirmware } = useFindAllFirmwareQuery({});
  const { sortModel, handleSortModelChange } = useGridSort('id', 'desc');
  if (allFirmware === undefined) return <CircularProgress></CircularProgress>;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'link', hide: true },
    { field: 'userguideLink', hide: true },
    {
      field: 'name',
      headerName: 'Firmware',
      width: 180,
      renderCell: (params: GridCellParams) => (
        <LinkNewTab href={params.row.link} label={params.row.name} />
      ),
    },
    { field: 'analyzerType', headerName: 'Hardware Type', width: 180 },
    {
      field: 'changelog',
      headerName: 'Changelog',
      width: 150,
      renderCell: (params: GridCellParams) =>
        params.row.changelog ? (
          <LinkNewTab href={params.row.changelog} label='Changelog' />
        ) : (
          ' '
        ),
    },
    {
      field: 'userguide',
      headerName: 'User Guide',
      width: 200,
      renderCell: (params: GridCellParams) => (
        <LinkNewTab
          href={params.row.userguideLink}
          label={params.row.userguide}
        />
      ),
    },
  ];
  const rows = allFirmware
    .filter((item: Firmware) => filterFirmware(item, filters))
    .map((item: Firmware) => ({
      id: item.id,
      name: item.name,
      link: item.link,
      analyzerType: item.hardwareType.typeName,
      changelog: item.changelog,
      userguide: item.userguideName,
      userguideLink: item.userguideLink,
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedFirmware(
      allFirmware.filter((version: Firmware) => model.includes(version.id))
    );
  };
  return (
    <>
      <div style={{ paddingBottom: '1rem', width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={100}
          checkboxSelection
          disableSelectionOnClick
          autoHeight
          disableColumnMenu={true}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          onSelectionModelChange={handleTableSelection}
        />
      </div>
    </>
  );
};

export default FirmwareTable;
